import React, { useContext } from 'react';
import { SSIAnchorContext } from '../../context/SSIAnchorContext';
import Anchor from '../Anchor';

type Props = {
  anchorBlockKey: string;
  offsetTop: number;
};

export const SSIAnchorWithContext = ({ anchorBlockKey, offsetTop }: Props): JSX.Element | null => {
  const value = useContext(SSIAnchorContext);

  if (!value.isVisible) {
    return null;
  }

  return (
    <Anchor
      anchorBlockKey={anchorBlockKey}
      offsetTop={offsetTop}
      documentId={value.documentId ?? ''}
      relationId={value.relationId ?? ''}
    />
  );
};
